window.NO_GLASS_DEDUCTION_MAP =
{
  "hinged": {
    "single_hinged": {
      "1068": {
        "full_lite": 58
      },
      "1080": {
        "full_lite": 88
      },
      "1268": {
        "full_lite": 58,
        "three_quarter_lite": 38
      },
      "1280": {
        "full_lite": 88,
        "three_quarter_lite": 58
      },
      "2068": {
        "full_lite": 79
      },
      "2080": {
        "full_lite": 79
      },
      "2268": {
        "full_lite": 79
      },
      "2280": {
        "full_lite": 79
      },
      "2668": {
        "full_lite": 95,
        "three_quarter_lite": 63
      },
      "2680": {
        "full_lite": 115,
        "three_quarter_lite": 95
      },
      "2868": {
        "full_lite": 109,
        "three_quarter_lite": 73
      },
      "2880": {
        "full_lite": 115,
        "three_quarter_lite": 109
      },
      "3068": {
        "full_lite": 120,
        "three_quarter_lite": 80
      },
      "3076": {
        "full_lite": 117
      },
      "3080": {
        "full_lite": 129,
        "three_quarter_lite": 120
      },
      "4068": {
        "full_lite": 158
      },
      "4080": {
        "full_lite": 158
      },
      "5068": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "5080": {
        "full_lite": 230,
        "three_quarter_lite": 190
      },
      "5468": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "5480": {
        "full_lite": 230,
        "three_quarter_lite": 219
      },
      "6068": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "6076": {
        "full_lite": 235
      },
      "6080": {
        "full_lite": 257,
        "three_quarter_lite": 239
      },
      "7668": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "7680": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "8068": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "8080": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "9068": {
        "full_lite": 359,
        "three_quarter_lite": 239
      },
      "9076": {
        "full_lite": 352
      },
      "9080": {
        "full_lite": 386,
        "three_quarter_lite": 328
      },
      "10611": {
        "full_lite": 58
      },
      "12611": {
        "full_lite": 58,
        "three_quarter_lite": 38
      },
      "20611": {
        "full_lite": 79
      },
      "22611": {
        "full_lite": 79
      },
      "26611": {
        "full_lite": 95,
        "three_quarter_lite": 63
      },
      "28611": {
        "full_lite": 109,
        "three_quarter_lite": 73
      },
      "30611": {
        "full_lite": 120,
        "three_quarter_lite": 80
      },
      "40611": {
        "full_lite": 158
      },
      "50611": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "54611": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "60611": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "76611": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "80611": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "90611": {
        "full_lite": 359,
        "three_quarter_lite": 239
      }
    },
    "double_hinged": {
      "4068": {
        "full_lite": 158
      },
      "4080": {
        "full_lite": 158
      },
      "5068": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "5080": {
        "full_lite": 230,
        "three_quarter_lite": 190
      },
      "5468": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "5480": {
        "full_lite": 230,
        "three_quarter_lite": 219
      },
      "6068": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "6076": {
        "full_lite": 235
      },
      "6080": {
        "full_lite": 257,
        "three_quarter_lite": 239
      },
      "40611": {
        "full_lite": 158
      },
      "50611": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "54611": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "60611": {
        "full_lite": 239,
        "three_quarter_lite": 159
      }
    },
    "center_hinged": {
      "5068": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "5080": {
        "full_lite": 230,
        "three_quarter_lite": 190
      },
      "5468": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "5480": {
        "full_lite": 230,
        "three_quarter_lite": 219
      },
      "6068": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "6076": {
        "full_lite": 235
      },
      "6080": {
        "full_lite": 257,
        "three_quarter_lite": 239
      },
      "7668": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "7680": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "8068": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "8080": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "9068": {
        "full_lite": 359,
        "three_quarter_lite": 239
      },
      "9076": {
        "full_lite": 352
      },
      "9080": {
        "full_lite": 386,
        "three_quarter_lite": 328
      },
      "50611": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "54611": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "60611": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "76611": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "80611": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "90611": {
        "full_lite": 359,
        "three_quarter_lite": 239
      }
    },
    "vented_sidelight": {
    "6068": {
      "full_lite": 296
    },
    "8068": {
      "full_lite": 366
    }
  },
  "folding": {
    "9080": {
      "full_lite": 386
    },
    "12080": {
      "full_lite": 515
    }
  }
},
  "gliding": {
    "gliding_2_panel": {
      "5068": {
        "full_lite": 212,
        "three_quarter_lite": 127
      },
      "5080": {
        "full_lite": 230,
        "three_quarter_lite": 190
      },
      "6068": {
        "full_lite": 263,
        "three_quarter_lite": 159
      },
      "6080": {
        "full_lite": 301,
        "three_quarter_lite": 239
      },
      "8068": {
        "full_lite": 372
      },
      "8080": {
        "full_lite": 432
      },
      "50611": {
        "full_lite": 212,
        "three_quarter_lite": 127
      },
      "60611": {
        "full_lite": 263,
        "three_quarter_lite": 159
      },
      "60710": {
        "full_lite": 315
      },
      "80611": {
        "full_lite": 372
      }
    },
    "gliding_3_panel": {
      "7668": {
        "full_lite": 318,
        "three_quarter_lite": 190
      },
      "7680": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "9068": {
        "full_lite": 394,
        "three_quarter_lite": 239
      },
      "9080": {
        "full_lite": 451,
        "three_quarter_lite": 359
      },
      "12068": {
        "full_lite": 557
      },
      "12080": {
        "full_lite": 648
      },
      "76611": {
        "full_lite": 318,
        "three_quarter_lite": 190
      },
      "90611": {
        "full_lite": 394,
        "three_quarter_lite": 239
      },
      "120611": {
        "full_lite": 557
      }
    },
    "gliding_4_panel": {
      "10068": {
        "full_lite": 423,
        "three_quarter_lite": 253
      },
      "10080": {
        "full_lite": 461,
        "three_quarter_lite": 380
      },
      "12068": {
        "full_lite": 526,
        "three_quarter_lite": 319
      },
      "12080": {
        "full_lite": 602,
        "three_quarter_lite": 478
      },
      "100611": {
        "full_lite": 423,
        "three_quarter_lite": 253
      },
      "120611": {
      "full_lite": 526,
      "three_quarter_lite": 319
    }
  },
  "gliding_bypass": {
    "9068": {
      "full_lite": 394
    },
    "90611": {
      "full_lite": 394
    },
    "9080": {
      "full_lite": 451
    }
  }
},
  "fixed": {
    "hinged_one_panel": {
      "1068": {
        "full_lite": 58
      },
      "1080": {
        "full_lite": 88
      },
      "1268": {
        "full_lite": 58,
        "three_quarter_lite": 38
      },
      "1280": {
        "full_lite": 88,
        "three_quarter_lite": 58
      },
      "2068": {
        "full_lite": 79
      },
      "2080": {
        "full_lite": 79
      },
      "2668": {
        "full_lite": 95,
        "three_quarter_lite": 63
      },
      "2680": {
        "full_lite": 115,
        "three_quarter_lite": 95
      },
      "2868": {
        "full_lite": 109,
        "three_quarter_lite": 73
      },
      "2880": {
        "full_lite": 115,
        "three_quarter_lite": 109
      },
      "3068": {
        "full_lite": 120,
        "three_quarter_lite": 80
      },
      "3076": {
        "full_lite": 117
      },
      "3080": {
        "full_lite": 129,
        "three_quarter_lite": 120
      },
      "10611": {
        "full_lite": 58
      },
      "12611": {
        "full_lite": 58,
        "three_quarter_lite": 38
      },
      "20611": {
        "full_lite": 79
      },
      "26611": {
        "full_lite": 95,
        "three_quarter_lite": 63
      },
      "28611": {
        "full_lite": 109,
        "three_quarter_lite": 73
      },
      "30611": {
        "full_lite": 120,
        "three_quarter_lite": 80
      }
    },
    "hinged_two_panel": {
      "4068": {
        "full_lite": 158
      },
      "4080": {
        "full_lite": 158
      },
      "5068": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "5080": {
        "full_lite": 230,
        "three_quarter_lite": 190
      },
      "5468": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "5480": {
        "full_lite": 230,
        "three_quarter_lite": 219
      },
      "6068": {
        "full_lite": 239,
        "three_quarter_lite": 159
      },
      "6076": {
        "full_lite": 235
      },
      "6080": {
        "full_lite": 257,
        "three_quarter_lite": 239
      },
      "40611": {
        "full_lite": 158
      },
      "50611": {
        "full_lite": 190,
        "three_quarter_lite": 127
      },
      "54611": {
        "full_lite": 219,
        "three_quarter_lite": 146
      },
      "60611": {
        "full_lite": 239,
        "three_quarter_lite": 159
      }
    },
    "hinged_three_panel": {
      "7668": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "7680": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "8068": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "8080": {
        "full_lite": 346,
        "three_quarter_lite": 285
      },
      "9068": {
        "full_lite": 359,
        "three_quarter_lite": 239
      },
      "9076": {
        "full_lite": 352
      },
      "9080": {
        "full_lite": 386,
        "three_quarter_lite": 328
      },
      "76611": {
        "full_lite": 285,
        "three_quarter_lite": 190
      },
      "80611": {
        "full_lite": 328,
        "three_quarter_lite": 219
      },
      "90611": {
        "full_lite": 359,
        "three_quarter_lite": 239
      }
    },
    "gliding_one_panel": {
      "2668": {
        "full_lite": 106,
        "three_quarter_lite": 63
      },
      "2680": {
        "full_lite": 115,
        "three_quarter_lite": 95
      },
      "3068": {
        "full_lite": 131,
        "three_quarter_lite": 80
      },
      "3080": {
        "full_lite": 150,
        "three_quarter_lite": 120
      },
      "4068": {
        "full_lite": 186
      },
      "4080": {
        "full_lite": 216
      },
      "26611": {
        "full_lite": 106,
        "three_quarter_lite": 63
      },
      "30611": {
        "full_lite": 131,
        "three_quarter_lite": 80
      },
      "40611": {
        "full_lite": 186
      }
    }
  }
}